export const I18N_LANGUAGES = ['en', 'de', 'fr'];
export const I18N_FALLBACK_LNG = 'en';
